import { inject, injectable } from "inversify";
import {
  ClientPortalProposedWorkDetailsModel,
  ClientPortalProposedWorkDocumentModel,
  ClientPortalProposedWorkFiltersModel,
  ClientPortalProposedWorkModel,
  ICPLClientPortalProposedWorksClient,
} from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientPortalProposedWorksService {
  getProposedWorks(
    proposedWorkFiltersModel: ClientPortalProposedWorkFiltersModel
  ): Promise<Array<ClientPortalProposedWorkModel>>;
  getProposedWorksDetail(proposedWorksID: string): Promise<ClientPortalProposedWorkDetailsModel>;
  voteOnProposedWork(proposedWorksID: string, agreed: boolean);
  getProposedWorkDocuments(proposedWorksID: string): Promise<ClientPortalProposedWorkDocumentModel[]>;
}

@injectable()
export class ClientPortalProposedWorksService implements IClientPortalProposedWorksService {
  @inject(SERVICE_TYPES.CPLClientPortalProposedWorksClient)
  cplClientPortalProposedWorksClient!: ICPLClientPortalProposedWorksClient;

  async getProposedWorks(
    proposedWorkFiltersModel: ClientPortalProposedWorkFiltersModel
  ): Promise<ClientPortalProposedWorkModel[]> {
    return await this.cplClientPortalProposedWorksClient.getProposedWorks(proposedWorkFiltersModel);
  }

  async getProposedWorksDetail(proposedWorksID: string): Promise<ClientPortalProposedWorkDetailsModel> {
    return await this.cplClientPortalProposedWorksClient.getProposedWorkDetails(proposedWorksID);
  }

  async voteOnProposedWork(proposedWorksID: string, agreed: boolean): Promise<void> {
    await this.cplClientPortalProposedWorksClient.voteOnProposedWork(proposedWorksID, agreed);
  }

  async getProposedWorkDocuments(proposedWorksID: string): Promise<ClientPortalProposedWorkDocumentModel[]> {
    return await this.cplClientPortalProposedWorksClient.getProposedWorkDocuments(proposedWorksID);
  }
}
